<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed">
    <i scActivityIcon class="fa-sharp fa-solid fa-star"></i>
    @if (context == 'candidate') {
    {{ texts.feedbackCandidateContext[language] }}
    } @else {
    {{ texts.feedbackPrefix[language] }} <strong>{{ activity.Candidate?.FirstName }} {{ activity.Candidate?.LastName }}</strong> {{ texts.feedbackSuffix[language] }}
    }
    <div scActivityBody>
        <sc-star-rating isReadOnly="true" [rating]="activity.Payload?.Value"></sc-star-rating>
        <p [innerHTML]="activity.Payload?.Comment"></p>
    </div>
</sc-activity-list-item>
